import { TypeformEmbed } from '@psyomics/ui-common';
import { Header, Illustration, PageLayout } from '@psyomics/ui-components';
import { useTranslation } from 'react-i18next';

const OPT_OUT_FEEDBACK = 'cYkwCZzJ';

const SmsOptOutSuccess = () => {
  const { t } = useTranslation();

  return (
    <PageLayout>
      <div className="flex flex-col justify-start items-start gap-7">
        <div className="w-full flex justify-center">
          <Illustration name="WomanOptOut" size={320} />
        </div>

        <Header level="h2">{t('page.smsOptOutSuccess.header')}</Header>

        <TypeformEmbed contract={null} type={OPT_OUT_FEEDBACK} />
      </div>
    </PageLayout>
  );
};

export { SmsOptOutSuccess };
